import { LitElement, html, css } from 'lit';
import { validateForm } from '../../utilities/formsUtilities';
import { accessibility, formStyles } from '../../utilities/styles';
export class AllInEmailConfirmation extends LitElement {
    static properties = {
        _confirmation: { type: String, state: true },
        resturl: { type: String },
        nonce: { type: String },
        config_hardlinks: { type: Object, reflect: true },
        supportEmail: { type: String },
        verifyEmailLink: { type: String },
    };
    constructor() {
        super();
        this.supportEmail = 'https://allin.zendesk.com/hc/en-gb/articles/4945686282143-Contact-us';
        this.verifyEmailLink = '/verify-your-email/';
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        let queryString = window.location.search;
        let params = new URLSearchParams(queryString);
        this.token = params.get('token_hash');
        if (this.token) {
            this.message = html `\n                <h3>Email Confirmation</h3>\n                <button @click="${this.handleVerification}" class="button decorative">Complete your verification</button>\n                <p class="resend-verify-email">Email confirmation link has expired? <a href="${this.verifyEmailLink}" target="_blank">Resend your verification email</a> or <a href="${this.supportEmail}">contact us</a>.</p>\n            `;
        }
        else {
            let confirmation_message = window.location.hash;
            if (confirmation_message && confirmation_message.includes('otp_expired')) {
                this.message = html `<p>The link you followed has expired.</p>\n                    <p>If you weren't expecting this link to be expired, please contact your IT department to check if this domain (https://allin.online) is in the allowlist.</p>\n                    <p><a href="${this.config_hardlinks.verify_your_email}">Please request a new one</a></p>`;
                this.header = 'Link Expired';
                let header = document.querySelector('h1');
                if (header) {
                    header.innerHTML = this.header;
                }
            }
            else {
                this.message = html `<p>Your email has been verified</p><p><a href="${this.config_hardlinks.login}">Login to your account</a></p>`;
            }
        }
    }
    render() {
        if (this._confirmation) {
            return html `\n                <div class="">\n                    <div class="bg">\n                        <h3>Email Confirmation</h3>\n                        <p>${this._confirmation}</p>\n                    </div>\n                </div>\n            `;
        }
        return html ` \n            <div class="">\n                <div class="bg">\n                    ${this.message}\n                </div>\n            </div>\n        `;
    }
    handleVerification() {
        if (this.token) {
            fetch(this.resturl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Verify': 'verify',
                },
                body: JSON.stringify({ token_hash: this.token }),
            })
                .then(response => response.json())
                .then(data => {
                if (data.ok) {
                    this._confirmation = data.message;
                    window.location.href = data.redirect;
                }
                else {
                    this._confirmation = html `There was an error verifying your email. <a href="${this.config_hardlinks.verify_your_email}">Request a new email verification.</a>`;
                }
            })
                .catch(error => {
                console.error('Error:', error);
            });
        }
    }
}
